import AuditSections from "const/AuditSections";
import AuditSubsectionRoutes from "const/AuditSubsectionRoutes";

export default class Audit {
  static getStatPropByRoute(route) {
    const matchingRouteEntry = Object.entries(AuditSubsectionRoutes)
      .find(([, subsectionRoute]) => subsectionRoute === route);

    return matchingRouteEntry ? AuditSections[matchingRouteEntry[0]] : undefined;
  }
}
